export function getMemory() {
  // memory data is unavailable in Safari, Firefox
  const memory = (window.performance as any)?.memory;

  if (!memory) {
    return undefined;
  }

  return {
    totalJSHeapSize: memory.totalJSHeapSize,
    usedJSHeapSize: memory.usedJSHeapSize,
    jsHeapSizeLimit: memory.jsHeapSizeLimit,
  };
}

export function isOutOfMemoryError(error: Pick<Error, 'message'>, isStartup: boolean) {
  const message = error.message.toLowerCase();

  if (isStartup && message === 'unreachable') {
    return true;
  }

  return message.includes('out of memory') || message.includes('could not allocate memory');
}
